import { ContactProperties } from 'forms-utils-lib/constants/Properties';
import defaultValidation from 'forms-utils-lib/formField/constants/defaultValidation';
import ValidationKeys from 'forms-utils-lib/constants/formField/ValidationKeys';
export const DefaultValidation = {
  [ContactProperties.phone]: {
    MIN_LENGTH: 7,
    MAX_LENGTH: 20
  }
};
const getMinMaxValidation = fieldType => {
  const {
    MIN_LENGTH,
    MAX_LENGTH
  } = DefaultValidation[fieldType];
  return Object.assign({}, defaultValidation, {
    [ValidationKeys.DATA]: `${MIN_LENGTH}:${MAX_LENGTH}:true`
  });
};
const generateValidation = (fieldName = 'email') => {
  if (fieldName === ContactProperties.phone || fieldName === ContactProperties.mobilephone) {
    return getMinMaxValidation(ContactProperties.phone);
  }
  return defaultValidation;
};
export default generateValidation;